import app from "nystem";
import { Link, Button, Icon } from "nystem-components";

const ViewLinkView = ({ model, value }) => {
  const { renderType, className, contentType, view: toView, text, add, addId, btnType, size } = model;
  const children = model.icon ? <Icon icon={model.icon} title={app.t(text)} className="h-5 w-5" /> : app.t(text);

  let href = `/${contentType}/${toView}`;
  if (addId && value) href += `/${value._id}`;

  if (renderType === "button")
    return (
      <Button type={btnType} size={size} to={(add || "") + href} className={className} Component={Link}>
        {children}
      </Button>
    );

  return (
    <Link type={renderType || "list"} to={(add || "") + href} className={className} addSearch={model.addSearch}>
      {children}
    </Link>
  );
};

export default ViewLinkView;
